const onReady = (callback) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
        return;
    }

    callback();
};

const initAccordion = () => {
    document.querySelectorAll('.accordion-list-application').forEach((accordion) => {
        accordion.addEventListener('click', (event) => {
            const item = event.target.closest('li');

            if (!item || !accordion.contains(item)) {
                return;
            }

            event.preventDefault();

            const isActive = item.classList.contains('active');

            accordion.querySelectorAll(':scope > li').forEach((listItem) => {
                listItem.classList.remove('active');
            });

            if (!isActive) {
                item.classList.add('active');
            }
        });
    });
};

export default () => onReady(initAccordion);
